import { useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { solicitudesApi } from "@/features/solicitudes/services/solicitudes.api";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Hook auxiliar para activar polling sobre la solicitud cuando una
 * pantalla necesita reaccionar a cambios server-side (ej. dispatch
 * outbox propagando un documento al checklist).
 *
 * Comparte cache con `useSolicitud` (suspense) · ambos observan la
 * misma queryKey. Pasar `intervalMs = false` para desactivar.
 */
export function useSolicitudPolling(
  solicitudId: string,
  intervalMs: number | false
) {
  return useQuery<SolicitudDetalle>({
    queryKey: qk.solicitud(solicitudId),
    queryFn: () => solicitudesApi.obtener(solicitudId),
    refetchInterval: intervalMs,
    enabled: intervalMs !== false,
  });
}
